import axios from 'api/axios'
import { Payment } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

export type TxnChannelType =
	| 'PAYTM'
	| 'UPI'
	| 'RAZORPAY'
	| 'OFFLINE'
	| 'RTGS/NEFT'
	| 'CHEQUE'
	| 'BANK_TRANSFER'

/**
 * Type Interface of objects that can be used in the API for Accept Payment
 */

export interface AcceptPaymentBody {
	amount: number
	remarks: string
	txnChannel: TxnChannelType
	url?: string
	paymentId: string
}

/**
 * API call for Accept Payment
 * @param body AcceptPaymentBody - data to be send to backend for accept Payment
 * @returns PaymentResponse - Response object returned from the server
 */

export const acceptPayment = async (id: string, body: AcceptPaymentBody) => {
	try {
		const { data } = await axios.post<Payment>(
			`client/bill/invoice/${id}/payment`,
			body
		)

		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default acceptPayment
